var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkplaceEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 5.91634V4.24967H8.33366V5.91634H11.667ZM3.33366 7.58301V16.7497H16.667V7.58301H3.33366ZM16.667 5.91634C17.592 5.91634 18.3337 6.65801 18.3337 7.58301V16.7497C18.3337 17.6747 17.592 18.4163 16.667 18.4163H3.33366C2.40866 18.4163 1.66699 17.6747 1.66699 16.7497L1.67533 7.58301C1.67533 6.65801 2.40866 5.91634 3.33366 5.91634H6.66699V4.24967C6.66699 3.32467 7.40866 2.58301 8.33366 2.58301H11.667C12.592 2.58301 13.3337 3.32467 13.3337 4.24967V5.91634H16.667Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkplaceEnglish);
export default __webpack_public_path__ + "static/media/workplace-english.9cf08da84b9051de6e30f53b4b9f2fdd.svg";
export { ForwardRef as ReactComponent };